<template>
    <div class="form-wrap">
        <div class="form-item">
            <div class="item-title">申请BU：</div>
            <div class="item-text">{{ data.bu_name }}</div>
        </div>
        <!-- <div class="form-item">
            <div class="item-title">快币类型：</div>
            <div class="item-text">{{  }}</div>
        </div> -->
        <div class="form-item">
            <div class="item-title">申请金额：</div>
            <div class="item-text">{{ `${data.trans_amount}${data.currency_name}` }}</div>
        </div>
        <div class="form-item">
            <div class="item-title">申请理由：</div>
            <div class="item-text">{{ data.remark }}</div>
        </div>
        <div class="form-item" v-show="data.status!=1">
            <div class="item-title">审核说明：</div>
            <div class="item-text">{{ data.result }}</div>
        </div>


        <sliderHistoty :data="data.req"></sliderHistoty>

        <!-- 审核 -->
        <div v-if="data.status==1 && $route.name!='my-application'"  v-form:apply-budget>
            <div class="form-line" text="审核处理"></div>

            <div class="form-item">
                <div class="item-title">审核说明：</div>
                <div class="item-wrap">
                    <textarea rule="reason" v-arg="'审核说明'" v-tar="examine.result" v-model="examine.result" placeholder="请输入审核说明"></textarea>
                </div>
            </div>

            <div class="form-footer">
                <el-button type="primary" @click="checkPass">通 过</el-button>
                <el-button type="primary" @click="checkNotPass">不通过</el-button>
            </div>
        </div>

        <!-- 重新提交 -->
        <div v-if="data.status == 3 &&  $route.name=='my-application'" v-form:budget-again>
            <div class="form-line" text="申请"></div>

            <!-- <div class="form-item">
                <div class="item-title">快币类型：</div>
                <div class="item-text">
                    <el-select v-tar="resub.budget_typeId" rule="noVal" v-model="resub.budget_typeId" placeholder="请选择">
                        <el-option v-for="item in currency_list" :key="item.currency_id" :value="item.currency_id" :label="item.currency_name" >
                        </el-option>
                    </el-select> 
                </div>
            </div> -->
            <div class="form-item">
                <div class="item-title">申请金额：</div>
                <div class="item-text limit">
                     <el-input v-tar="resub.budget_amount" rule="noVal number" v-model="resub.budget_amount" placeholder="请输入数字">
                        <template slot="append">{{ task_curr.currency_name }}</template>
                    </el-input>
                </div>
            </div>
            <div class="form-item">
                <div class="item-title">申请理由：</div>
                <div class="item-wrap">
                    <textarea v-tar="resub.budget_reason" rule="reason" v-arg="['申请理由']" v-model="resub.budget_reason" placeholder="请输入申请理由"></textarea>
                </div>
            </div>
            <div class="form-footer">
                <el-button type="primary" @click="subAgain">重新提交</el-button>
            </div>

        </div>

    </div>
</template>

<script>
    import sliderHistoty from "src/components/slider/slider_history.vue"
    import { mapGetters } from "vuex"

    export default {
        props:{
            data:{
                type: Object,
                default: function(){
                    return {};
                },
                required: true,
            },
            resub:{
                type: Object,
                default: function(){
                    return {};
                },
            },
            examine:{
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        components:{
            sliderHistoty,
        },
        data(){
            return {

            }
        },

        computed:{
            ...mapGetters(['task_curr']),
            // ...mapGetters(["canCurrency"]),
            // verify(){  //审核的数据
            //     return this.examine || {};
            // },
            currency_list(){
                return this.data.budgetCurrAccountInfoList || [];
            }
        },

        watch:{
            data(val){
                let count = 0;
                for(let i in val){
                    count++;
                };
                if(count == 0){
                    this.$form.clear("budget-again");
                    this.$form.clear("apply-budget");
                }
            },
        },

        methods:{
            checkPass(){
                let res = this.$form.check("apply-budget");
                if(!res){
                    return;
                }
                this.$emit('pass');
            },
            checkNotPass(){
                let res = this.$form.check("apply-budget");
                if(!res){
                    return;
                }
                this.$emit('notpass');
            },
            subAgain(){  //重提交
                let res = this.$form.check("budget-again");
                if(!res){
                    return;
                }

                let url = `api/manager/curr_bgt_req/${this.data.id}`;
                this.$http.put(url,{
                    // currency_id:this.resub.budget_typeId,
                    trans_amount:this.resub.budget_amount,
                    remark:this.resub.budget_reason,
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("重新提交成功");
                        this.$emit("refresh");
                    }
                }).catch(error=>{
                    this.errorTip("提交失败");
                });

            },
        }
    }
</script>

<style lang="less" scoped>
    @import "~src/assets/less/slider.less";
</style>





// WEBPACK FOOTER //
// sliderBudget.vue?875d7310